module.exports = __webpack_public_path__ + "static/xp-logo-e0df595cbf1c955f0bf2a7219ea71189.png";